import React, { useState, useRef, useEffect, useCallback } from 'react';
import Cookies from 'universal-cookie';
import { useResolvedPath } from 'react-router-dom';
import styles from './sideBar.module.css';

import SideBarItem from '../SideBarItem/SideBarItem';

// icons
import { logo } from '../../brand/assets';
import cars from '../../brand/generated/sidebar/cars.svg';
import clients from '../../brand/generated/sidebar/clients.svg';
import deals from '../../brand/generated/sidebar/deals.svg';
import equipment from '../../brand/generated/sidebar/equipment.svg';
import services from '../../brand/generated/sidebar/services.svg';
import leads from '../../brand/generated/sidebar/leads.svg';
import profile from '../../brand/generated/sidebar/profile.svg';
import reports from '../../brand/generated/sidebar/report.svg';
import records from '../../brand/generated/sidebar/records.svg';
import upload from '../../brand/generated/sidebar/upload.svg';
import arrow from '../../brand/generated/header/arrowUser.svg';
import Menu from './Menu';
import getMenuItemCount from '../../api/sidebar/getMenuItemCount';
import axios from '../../plugins/axios';
import { socket } from '../../App';
import isUserHaveRole from '../../utils/isUserHaveRole';
import alertHelper from '../../helpers/alert';
import {
  ROLE_NOTARY,
  ROLE_MANAGER,
  PERMISSION_CAN_SEE_ALL_LEADS,
  PERMISSION_CAN_SEE_SERVICES,
  PERMISSION_CAN_SEE_RECORDS,
  PERMISSION_CAN_SEE_REPORTS,
  PERMISSION_CAN_SEE_PERMISSIONS,
  PERMISSION_CAN_SEE_ALL_DEALS,
  ROLE_ADMIN,
  ROLE_DIRECTOR,
  ROLE_FINANCE,
  ROLE_ROP,
  ROLE_MOP,
} from '../../constants/roles';
import LoaderInline from '../Loader/LoaderInline';
import { useSelector } from 'react-redux';
import logout from '../../helpers/logout';
import isUserHavePermission from '../../utils/isUserHavePermission';
import { usedOnlyMenuChildren } from '../../brand/tenant';

const SideBar = ({ to, isOpen, onClose }) => {
  const user = useSelector((state) => state.user);
  const [checking, setChecking] = useState(false);

  const checkConnection = async () => {
    if (checking) return;
    setChecking(true);

    const results = {
      internet: navigator.onLine,
      server: false,
      socket: socket?.state === 'Connected',
    };

    try {
      await axios.get('/api/user?time=' + new Date().getTime(), { timeout: 5000 });
      results.server = true;
    } catch (e) {
      results.server = false;
    }

    setChecking(false);

    if (results.internet && results.server && results.socket) {
      alertHelper.success('Ð¡Ð¾ÐµÐ´Ð¸Ð½ÐµÐ½Ð¸Ðµ Ñ ÑÐµÑÐ²ÐµÑÐ¾Ð¼ ÑÑÐ¿ÐµÑÐ½Ð¾');
    } else {
      const issues = [];
      if (!results.internet) issues.push('ÐÐµÑ Ð¸Ð½ÑÐµÑÐ½ÐµÑÐ°');
      if (!results.server) issues.push('Ð¡ÐµÑÐ²ÐµÑ Ð½ÐµÐ´Ð¾ÑÑÑÐ¿ÐµÐ½');
      if (!results.socket) issues.push('ÐÑÐ¸Ð±ÐºÐ° ÑÐ¾ÐµÐ´Ð¸Ð½ÐµÐ½Ð¸Ñ Ñ ÑÐµÑÐ²ÐµÑÐ¾Ð¼');
      alertHelper.error(issues.join(', '));
    }
  };

  const getSidebarItems = useCallback(() => {
    return isUserHaveRole(ROLE_NOTARY)
      ? [
          { title: 'ÐÐ»Ð¸ÐµÐ½ÑÑ', name: 'client', icon: clients, path: '/notary/clients', chapterId: 3 },
          { title: 'Ð¡Ð´ÐµÐ»ÐºÐ¸', name: 'deal', icon: deals, path: '/notary/deals', chapterId: 5 },
        ]
      : [
          { title: 'ÐÐ»Ð¸ÐµÐ½ÑÑ', name: 'client', icon: clients, path: '/', chapterId: 3, count: 0,
            show: isUserHaveRole(ROLE_DIRECTOR) || isUserHaveRole(ROLE_ADMIN) || isUserHaveRole(ROLE_MANAGER) || isUserHaveRole(ROLE_ROP) || isUserHaveRole(ROLE_MOP),
           },
          {
            title: 'ÐÐ¸Ð´Ñ',
            name: 'lead',
            icon: leads,
            path: '/leads',
            chapterId: 4,
            count: 0,
            count_2: 0,
            show: isUserHavePermission(PERMISSION_CAN_SEE_ALL_LEADS),
          },
          {
            title: 'ÐÑÐ¾Ð´Ð°Ð¶Ð¸',
            name: 'deal',
            icon: deals,
            path: '/deals',
            chapterId: 5,
            count: 0,
            children: usedOnlyMenuChildren([
              { title: 'ÐÐ¾Ð²ÑÐµ Ð°Ð²ÑÐ¾', path: '/deals/new' },
              { title: 'ÐÐ£ Ð°Ð²ÑÐ¾', path: '/deals/used' },
            ]),
            show: isUserHavePermission(PERMISSION_CAN_SEE_ALL_DEALS),
          },
          {
            title: 'ÐÐµÑÐ´Ð°ÑÐ½ÑÐµ ÑÐ´ÐµÐ»ÐºÐ¸',
            name: 'rejected-deals',
            icon: deals,
            path: '/deals-rejected',
            chapterId: 23,
            count: 0,
            show: isUserHavePermission(PERMISSION_CAN_SEE_ALL_DEALS),
          },
          {
            title: 'ÐÐ²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ð¸',
            name: 'cars',
            icon: cars,
            path: '/cars',
            chapterId: 1,
            count: 0,
            count_2: 0,
            children: usedOnlyMenuChildren([
              { title: 'ÐÐ¾Ð²ÑÐµ Ð°Ð²ÑÐ¾', path: '/cars/new' },
              { title: 'ÐÐ£ Ð°Ð²ÑÐ¾', path: '/cars/used' },
              { title: 'ÐÐ°ÑÐºÐ¸', path: '/cars/marks' },
              { title: 'ÐÐ¾Ð´ÐµÐ»Ð¸', path: '/cars/models' },
              { title: 'ÐÐ°ÑÐºÐ° Ð¸ Ð¼Ð¾Ð´ÐµÐ»Ñ', path: '/cars/containers' },
            ]),
            show: isUserHaveRole(ROLE_DIRECTOR) || isUserHaveRole(ROLE_ADMIN) || isUserHaveRole(ROLE_MANAGER) || isUserHaveRole(ROLE_ROP) || isUserHaveRole(ROLE_MOP),
          },
          // {
          //   title: 'ÐÐ¾Ð¿. Ð¾Ð±Ð¾ÑÑÐ´Ð¾Ð²Ð°Ð½Ð¸Ðµ',
          //   chapterId: 2,
          //   name: 'equipments',
          //   icon: equipment,
          //   path: '/equipments',
          //   count: 0,
          // },
          {
            title: 'ÐÐ¾Ð¿. ÑÑÐ»ÑÐ³Ð¸',
            name: 'additionalServices',
            chapterId: 8,
            icon: services,
            path: '/services',
            count: 0,
            show: isUserHavePermission(PERMISSION_CAN_SEE_SERVICES),
          },
          {
            title: 'ÐÐ°Ð¿Ð¸ÑÐ¸',
            name: 'allService',
            icon: records,
            path: '/records',
            children: [
              { title: 'ÐÐ° ÑÐµÑÐ²Ð¸Ñ', path: '/records/service', name: 'service', count: 0, count_2: 0 },
              { title: 'ÐÐ° ÑÐµÑÑ-Ð´ÑÐ°Ð¹Ð²', path: '/records/test-drive', name: 'testDrive', count: 0, count_2: 0 },
              { title: 'ÐÑÐºÑÐ¿ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ', path: '/records/purchase', name: 'purchase', count: 0, count_2: 0 },
            ],
            count: 0,
            count_2: 0,
            arrow: arrow,
            show: isUserHavePermission(PERMISSION_CAN_SEE_RECORDS),
          },
          {
            title: 'ÐÑÑÐµÑÑ',
            name: '',
            icon: reports,
            path: '/reports',
            show: isUserHaveRole(ROLE_FINANCE) || isUserHaveRole(ROLE_ADMIN),
          },
          {
            title: 'ÐÐ¾Ð´Ð¿Ð¸ÑÐ°Ð½Ð¸Ðµ ÐÐÐ',
            name: 'dkp-sign',
            icon: deals,
            path: '/dkp-sign',
            chapterId: 24,
            count: 0,
            show: isUserHaveRole(ROLE_ADMIN) || isUserHaveRole(ROLE_DIRECTOR),
          },
          {
            title: 'Ð¡ÑÐ¾Ðº',
            name: 'stock',
            icon: upload,
            path: '/stock-upload',
            children: [
              { title: 'ÐÐ°Ð³ÑÑÐ·ÐºÐ° ÑÑÐ¾ÐºÐ°', path: '/stock-upload' },
              { title: 'ÐÑÑÐµÑ', path: '/stock-report' },
              { title: 'Ð¡ÑÐ¾Ðº Ð°Ð²ÑÐ¾', path: '/stock-cars' },
              { title: 'ÐÑÐ°Ð¹Ñ Ð¿Ð¾ Ð¿ÑÐ¸ÐºÐ°Ð·Ñ', path: '/price-list' },
            ],
            show: isUserHaveRole(ROLE_ADMIN) || isUserHaveRole(ROLE_ROP),
          },
          { title: 'ÐÑÐ¾ÑÐ¸Ð»Ñ', name: '', icon: profile, path: '/profile' },
          {
            title: 'ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ° ÑÐ¾Ð»ÐµÐ¹',
            name: 'permissions',
            icon: equipment,
            path: '/settings/permissions',
            show: isUserHaveRole(ROLE_ADMIN),
          },
        ].filter((item) => item.show || item.show === undefined);
  }, [user]);

  const [menuItems, setMenuItems] = React.useState([]);

  const { pathname } = useResolvedPath(to);
  const [loading, setLoading] = useState(true);

  const ref = useRef(null);

  const [menuCounter, setMenuCounter] = React.useState({});
  const [rerender, setRerender] = React.useState(0);

  useEffect(() => {
    init();
  }, [user]);

  const init = async () => {
    let test = getSidebarItems();
    const itemCounts = await axios.get('/api/crm/sidebar/getMenuItemCount');

    test.forEach((item) => {
      Object.keys(itemCounts.data).forEach((i, index) => {
        if (item.children) {
          item.children.forEach((child) => {
            if (child.name === i && itemCounts.data[i] > 0) child.count = itemCounts.data[i];
          });
          if (item.name === i && itemCounts.data[i] > 0) item.count = itemCounts.data[i];
        } else {
          if (item.name === i && itemCounts.data[i] > 0) item.count = itemCounts.data[i];
        }
      });
    });

    const notificationCount = await axios.get('/api/notifications/sidebar/getCrmSidebarNotificationsCount');

    if (isUserHaveRole(ROLE_NOTARY)) {
      test[1].count_2 = notificationCount.data.deal;
      test[0].count_2 = notificationCount.data.client;
    } else {
      if (test[4]) {
        test[4].count_2 = notificationCount.data.cars;
      }
      if (test[2]) {
        test[2].count_2 = notificationCount.data.lead;
      }

      if (test[5]) {
        test[5].count_2 = notificationCount.data.equipments;
      }
      if (test[6]) {
        test[6].count_2 = notificationCount.data.additionalServices;
      }
      if (test[7]) {
        test[7].count_2 = notificationCount.data.allService;
      }
      if (test[2]) {
        test[2].count_2 = notificationCount.data.deal;
      }
      if (test[0]) {
        test[0].count_2 = notificationCount.data.client;
      }
      // if (test[6]?.children?.[1]?.count_2) {
      //   test[6].children[1].count_2 = notificationCount.data.service;
      // }
      // if (test[6].children?.[0].count_2) {
      //   test[6].children[0].count_2 = notificationCount.data.testDrive;
      // }
    }

    setRerender(rerender + 1);
    setMenuItems(test);
    setLoading(false);
  };
  React.useEffect(() => {
    socket.on('listenCrmNavigationNotifications', (data) => {
      init();
    });
    return () => {
      socket.off('listenCrmNavigationNotifications');
    };
  }, [user]);

  React.useEffect(() => {
    const onSidebarRefresh = () => {
      init();
    };

    window.addEventListener('crmSidebarRefresh', onSidebarRefresh);
    return () => {
      window.removeEventListener('crmSidebarRefresh', onSidebarRefresh);
    };
  }, [user]);

  React.useEffect(() => {
    console.log('USER', user);
  }, [user]);

  return (
    <>
      <div id="sidebar" className={`${styles.sidebar} ${isOpen ? styles.open : ''}`}>
        <button type="button" aria-label="ÐÐ°ÐºÑÑÑÑ Ð¼ÐµÐ½Ñ" className={styles.closeBtn} onClick={onClose}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
        <div className={styles.sticky}>
          <img src={logo} alt="Logo" className={styles.logo} />
          <nav ref={ref}>{loading ? <LoaderInline /> : <Menu items={menuItems} onLinkClick={onClose} />}</nav>
          <hr />
          <button onClick={checkConnection} disabled={checking} className={styles.connectionBtn}>
            {checking ? (
              <svg width="16" height="16" viewBox="0 0 24 24" className={styles.spin}>
                <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" fill="none" strokeDasharray="31.4 31.4" />
              </svg>
            ) : (
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path d="M1 9L3 11C7.97 6.03 16.03 6.03 21 11L23 9C16.93 2.93 7.08 2.93 1 9ZM9 17L12 20L15 17C13.35 15.34 10.66 15.34 9 17ZM5 13L7 15C9.76 12.24 14.24 12.24 17 15L19 13C15.14 9.14 8.87 9.14 5 13Z"/>
              </svg>
            )}
            ÐÑÐ¾Ð²ÐµÑÐ¸ÑÑ ÑÐ¾ÐµÐ´Ð¸Ð½ÐµÐ½Ð¸Ðµ
          </button>
          <button onClick={logout} className={styles.exit}>
            ÐÑÑÐ¾Ð´
          </button>
        </div>
      </div>
      {isOpen && <div className={styles.overlay} onClick={onClose} />}
    </>
  );
};

export default SideBar;
